import { useEffect } from 'react'
import { GtmAccountSelector } from 'pages/workspace/asset/gtm'
import { useStores } from 'hooks'
import { InviteTeamMemberTracking } from '../invite-team-member-tracking'

interface GtmInstallProps {
	onComplete?: () => void
}

export const GtmInstall = ({ onComplete }: GtmInstallProps) => {
	const {
		accountStore: { account, getGtmLinks },
		assetStore: { asset, getGtmTag }
	} = useStores()

	useEffect(() => {
		if (account?.id) {
			getGtmLinks(account.id)
			if (asset?.id) {
				getGtmTag(account.id, asset.id)
			}
		}
	}, [account?.id, asset?.id])

	return (
		<div className="flex flex-col">
			<GtmAccountSelector onComplete={onComplete} />
			<InviteTeamMemberTracking />
		</div>
	)
}
